import { render, staticRenderFns } from "./ProjectWorkorderAdd.vue?vue&type=template&id=28000397"
import script from "./ProjectWorkorderAdd.vue?vue&type=script&lang=js"
export * from "./ProjectWorkorderAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports